import { Link } from "react-router-dom";
import styles from "./style/Mainpage.module.css";
import Music from "./image15.png";

function Mainpage() {
  return (
    <div className={styles.main}>
      <div className={styles.show} id="Show">
        <div className={styles.title}>Rhythm with Game</div>
        <div className={styles.text}>A playable website for music</div>
        <div className={styles.link}> </div>
        <Link to="/introduction" className={styles.link}>
          <div> Introduction</div>
        </Link>
        <Link to="/games" className={styles.link}>
          <div>Games</div>
        </Link>
        <Link to="/story" className={styles.link}>
          <div>Creator’s Story</div>
        </Link>
        <Link to="/music" className={styles.link}>
          <div>
          <img src={Music}/>
          {" "}  Enjoy the Music</div>
        </Link>
      </div>
    </div>
  );
}

export default Mainpage;
